import { Component, OnDestroy } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { ConfigurationService } from 'src/app/private/services/configuration.service';
import { AddCampaignComponent } from "../../components/manage-campaign/add-campaign/add-campaign.component";
import { BadgeModule } from 'primeng/badge';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PreviewWhatsappTemplateComponent } from "../../components/whatsapp-template/preview-whatsapp-template/preview-whatsapp-template.component";
import { PreviewEmailTemplateComponent } from "../../components/email-template/preview-email-template/preview-email-template.component";
import { ActivatedRoute, Router } from '@angular/router';
import { TestCallComponent } from "../../components/manage-campaign/test-call/test-call.component";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EmailReportComponent } from "./components/email-report/email-report.component";
import { WhatsappReportComponent } from "./components/whatsapp-report/whatsapp-report.component";
import * as moment from 'moment-timezone';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-manage-campaign',
  imports: [ToolBarComponent, SharedModule, AddCampaignComponent, BadgeModule, PreviewWhatsappTemplateComponent, PreviewEmailTemplateComponent, TestCallComponent, DragDropModule, EmailReportComponent, WhatsappReportComponent, NgxIntlTelInputModule],
  providers: [ConfirmationService],
  templateUrl: './manage-campaign.component.html',
  styleUrl: './manage-campaign.component.scss'
})
export class ManageCampaignComponent implements OnDestroy {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;
  btnLoading: boolean = false;

  // SIP Dialer properties
  sipDialerUrl: SafeResourceUrl;
  isMinimized: boolean = true;

  emailTemplates: any[] = [];
  whatsappTemplates: any[] = [];
  contactGroups: any[] = [];

  editData: any = {};
  accessObject: any = {};

  constructor(
    private api: ManageCampaignService,
    private configService: ConfigurationService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer,
    private route: Router,
    private activeRoute: ActivatedRoute
  ) {

    this.accessObject = this.localStorage.checkCRUDAccess('campaign', 'manual');

    console.log("Access Object: ", this.accessObject);
    
    // Initialize sanitized URL for SIP Dialer
    this.sipDialerUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://cdn.founderscart.com/app/ivrsolutions/sip/assets/html/index.html');
  }


  filtersOptions: any[] = [
    { header: 'Campaign Name', value: 'campaign_name', type: 'text' },
    { header: 'Status', value: 'status', type: 'text' },
  ];

  tabs: any[] = [
    { label: 'Whatsapp', value: 'whatsapp', icon: `/assets/images/WhatsApp.png` },
    { label: 'Email', value: 'email', icon: 'email' },
    { label: 'Call', value: 'call', icon: 'call' },
    // {label: 'SMS', value : 'sms'}
  ]




  displayedColumns: any[] = [
    { field: 'sno', header: 'S.No', type: 'sno' },
    { field: 'campaign_name', header: 'Campaign Name', type: 'campaign_name' },
    { field: 'contact_group', header: 'Contact Group', type: 'contact_group' },
    { field: 'createdAt', header: 'Campaign Date', type: 'date' },
    { field: 'is_schedule', header: 'Is Schedule', type: 'is_schedule' },
    { field: 'schedule_date', header: 'Schedule Date and Time', type: 'date' },
    { field: 'status', header: 'Status', type: 'status' },
    { field: 'action', header: 'Action', type: 'action' }
  ]

  isEditCampaign: boolean = false;
  isDeleteCampaign: boolean = false;
  isAddCampaign: boolean = false;
  isRunCampaign: boolean = false;

  isFetchingTemplates: boolean = false;
  whatsappPreviewTemplate: any = {};
  processedData: any = {};
  emailTemplateDocuments: any[] = [];

  openTestCallDialog: boolean = false;
  openTestEmailDialog: boolean = false;
  openTestWhatsappDialog: boolean = false;
  testPhoneNumber: any = '';
  testEmail: string = '';
  isEmailReportDialogOpen: boolean = false;
  isWhatsappReportDialogOpen: boolean = false;

  // Polling and state tracking
  private pollingIntervalId: any = null;
  currentFirst: number = 0; // track current page start index
  // track last applied filters so polling uses same query
  lastSearchValue?: string;
  lastSearchAttribute?: string;
  lastStartDate?: string;
  lastEndDate?: string;


  campaignActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditCampaign = true;
          }
        },

        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          command: () => {
            this.isRunCampaign = true;
            this.run(this.editData);
          }
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ]


  campaignActionItemsForCall: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditCampaign = true;
          }
        },

        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          command: () => {
            this.isRunCampaign = true;

            // check if marketing_campaign credentials exist before running call campaign
            const marketingCampaignCredentials = this.localStorage.getModuleMapping('marketing_campaign');
            if (!marketingCampaignCredentials) {
              console.log("No marketing campaign credentials found, prompting user.");
              this.confirmationService.confirm({
                key: 'emailConfigSteps',
                header: 'Email Configuration Required',
                message: 'Please connect your domain and assign a dedicated email address to send marketing campaigns.',
                acceptLabel: 'Connect Now',
                rejectLabel: 'Cancel',
                rejectVisible: true,
                accept: () => {
                  this.route.navigate(['/main/settings/configuration-panel']);
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
              return;
            }


            this.run(this.editData);
          }
        },
        {
          label: 'View Campaign Report',
          icon: 'pi pi-eye',
          command: () => {
            this.route.navigate(
              ['main/manage-campaign/call-campaign-details', this.editData.id],
              { queryParams: { name: this.editData.campaign_name } }
            );
          }

        },
        {
          label: 'Test Call',
          icon: 'pi pi-phone',
          command: () => {
            this.openTestCallDialog = true;
          }

        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ]


  active = "whatsapp"

  // Email Bottom Bar Properties
  assignedEmailForMarketing: string = '';
  assignedEmailData: any = null;
  emailMetricsLoading: boolean = false;

  ngOnInit() {
    this.fetchContactGroups(); // Fetch contact groups on initialization
    this.fetchEmailTemplates();
    this.fetchWhatsAppTemplates();

    this.activeRoute.queryParams.subscribe(params => {
      const type = params['type'];
      if (type === 'call') {
        this.active = 'call';
      }
    });


    this.tabs = this.tabs.filter(tab => {
      if (tab.value === 'whatsapp') {
        return this.accessObject?.whatsappCampaign == true
      }
      if (tab.value === 'email') {
        return this.accessObject?.emailCampaign == true
      }
      if (tab.value === 'call') {
        return this.accessObject?.callCampaign == true
      }
      return false;
    });

    this.active = this.tabs.length > 0 ? this.tabs[0].value : '';

    // Initial load
    this.loadData({ first: 0, rows: this.rows });

    // Start background polling for status updates every 30 seconds
    this.startPolling();

  }


  handleAddCampaign() {
    // Check if marketing_campaign credentials exist before adding email campaign
    console.log("Active Tab: ", this.active);
    console.log("Local Storage: ", this.localStorage.getModuleMapping('marketing_campaign'));
    if (this.active === 'email') {
      const marketingCampaignCredentials = this.localStorage.getModuleMapping('marketing_campaign');
      
      if (!marketingCampaignCredentials) {
        console.log("No marketing campaign credentials found, prompting user.");
        this.confirmationService.confirm({
          key: 'emailConfigSteps',
          header: 'Email Configuration Required',
          message: 'Please connect your domain and assign a dedicated email address to send marketing campaigns.',
          acceptLabel: 'Connect Now',
          rejectLabel: 'Cancel',
          rejectVisible: true,
          accept: () => {
            this.route.navigate(['/main/settings/configuration-panel']);
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
        return;
      }
    }

    // Check if WhatsApp configuration exists before adding WhatsApp campaign
    if (this.active === 'whatsapp') {
      const isWhatsappExist = this.localStorage.getIsWhatsappExist();
      
      if (!isWhatsappExist) {
        console.log("No WhatsApp configuration found, prompting user.");
        this.confirmationService.confirm({
          key: 'whatsappConfigSteps',
          header: 'WhatsApp Configuration Required',
          message: 'Please add your WhatsApp configuration to create and manage WhatsApp campaigns.',
          acceptLabel: 'Add Configuration',
          rejectLabel: 'Cancel',
          rejectVisible: true,
          accept: () => {
            this.route.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 2 } });
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
        return;
      }
    }

    this.isAddCampaign = true;
  }


  loadData(event: any, searchValue?: string, searchAttribute?: string, startDate?: string, endDate?: string, silent: boolean = false) {
    // update current pagination and filters
    this.currentFirst = event?.first ?? this.currentFirst;
    this.rows = event?.rows ?? this.rows;
    this.lastSearchValue = searchValue;
    this.lastSearchAttribute = searchAttribute;
    this.lastStartDate = startDate;
    this.lastEndDate = endDate;

    if (!silent) {
      this.loading = true;
    }

    if (this.active === 'call') {
      this.displayedColumns = this.displayedColumns.filter(col => col.field !== 'is_schedule' && col.field !== 'schedule_date' && col.field !== 'action'
        && col.field != 'number_of_batches' && col.field != 'batch_delay' && col.field != 'call_delay' && col.field != 'schedule_time'
      );

      // push no_of_batches and batch_delay and call_delay with type additional_details
      this.displayedColumns.push({ field: 'number_of_batches', header: 'No. of Batches', type: 'additional_details' });
      this.displayedColumns.push({ field: 'batch_delay', header: 'Batch Delay (in mins)', type: 'additional_details' });
      this.displayedColumns.push({ field: 'call_delay', header: 'Call Delay (in secs)', type: 'additional_details' });
      this.displayedColumns.push({ field: 'is_schedule', header: 'Is Schedule', type: 'is_schedule' });
      this.displayedColumns.push({ field: 'schedule_date', header: 'Schedule Date', type: 'date' });
      this.displayedColumns.push({ field: 'schedule_time', header: 'Schedule Time', type: 'time' });
      this.displayedColumns.push({ field: 'action', header: 'Action', type: 'action' });
      
      // Ensure S.No is at the beginning
      if (!this.displayedColumns.find(col => col.field === 'sno')) {
        this.displayedColumns.unshift({ field: 'sno', header: 'S.No', type: 'sno' });
      }

    } else {
      this.displayedColumns = [
        { field: 'sno', header: 'S.No', type: 'sno' },
        { field: 'campaign_name', header: 'Campaign Name', type: 'campaign_name' },
        { field: 'contact_group', header: 'Contact Group', type: 'contact_group' },
        { field: 'createdAt', header: 'Campaign Date', type: 'date' },
        { field: 'is_schedule', header: 'Is Schedule', type: 'is_schedule' },
        { field: 'schedule_date', header: 'Schedule Date and Time', type: 'date' },
        { field: 'status', header: 'Status', type: 'status' },
        { field: 'action', header: 'Action', type: 'action' }
      ]
    }

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campaign_type": this.active,
      },
      "page": page,
      "limit": size,
      "order": {
        "col": "\"campaign\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (searchValue && searchAttribute) {
      body.filter = {
        ...body.filter,
        [searchAttribute]: searchValue
      }
    }

    if (startDate && endDate) {
      body.startDate = startDate;
      body.endDate = endDate;
    }

    this.api.getAllManangeCampaign(body).subscribe({
      next: (data) => {
        this.dataSource = data.rows
        this.totalRecords = data.count;
        if (!silent) {
          this.loading = false;
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error fetching data' });
        if (!silent) {
          this.loading = false;
        }
      },
    });
  }


  reloadDataTable() {
    this.currentFirst = 0;
    this.loadData({ first: 0, rows: this.rows });
  }

  handleSearch(event: any) {
    console.log(event);
    // update last search filters so polling uses same search
    this.lastSearchValue = event.value;
    this.lastSearchAttribute = event.selectedFilterAttribute;
    this.currentFirst = 0;
    this.loadData({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }

  setTemplateEditData(data: any) {
    this.editData = data;
  }


  scheduleCallActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditCampaign = true;
          }
        },
        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          disabled: true
        },
        {
          label: 'View Campaign Report',
          icon: 'pi pi-eye',
          command: () => {
            this.route.navigate(
              ['main/manage-campaign/call-campaign-details', this.editData.id],
              { queryParams: { name: this.editData.campaign_name } }
            );
          }
        },
        {
          label: 'Test Call',
          icon: 'pi pi-phone',
          command: () => {
            this.openTestCallDialog = true;
          }
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ];

  completedCallActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          disabled: true,

        },
        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          disabled: true
        },
        {
          label: 'View Campaign Report',
          icon: 'pi pi-eye',
          command: () => {
            this.route.navigate(
              ['main/manage-campaign/call-campaign-details', this.editData.id],
              { queryParams: { name: this.editData.campaign_name } }
            );
          }
        },
        {
          label: 'Test Call',
          icon: 'pi pi-phone',
          disabled: true
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ];


  callActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditCampaign = true;
          }
        },
        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          command: () => {
            this.isRunCampaign = true;
            this.run(this.editData);
          }
        },
        {
          label: 'View Campaign Report',
          icon: 'pi pi-eye',
          command: () => {
            this.route.navigate(
              ['main/manage-campaign/call-campaign-details', this.editData.id],
              { queryParams: { name: this.editData.campaign_name } }
            );
          }
        },
        {
          label: 'Test Call',
          icon: 'pi pi-phone',
          command: () => {
            this.openTestCallDialog = true;
          }
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ]

  scheduleEmailWhatsappActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditCampaign = true;
          }
        },
        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          disabled: true
        },
        {
          label: 'View Report',
          icon: 'pi pi-chart-bar',
          command: () => {
            if (this.active === 'email') {
              this.isEmailReportDialogOpen = true;
            } else if (this.active === 'whatsapp') {
              this.isWhatsappReportDialogOpen = true;
            }
          }
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ];

  completedEmailWhatsappActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Campaign',
          icon: 'pi pi-fw pi-pencil',
          disabled: true
        },
        {
          label: 'Run Campaign',
          icon: 'pi pi-send',
          disabled: true
        },
        {
          label: 'View Report',
          icon: 'pi pi-chart-bar',
          command: () => {
            if (this.active === 'email') {
              this.isEmailReportDialogOpen = true;
            } else if (this.active === 'whatsapp') {
              this.isWhatsappReportDialogOpen = true;
            }
          }
        },
        {
          label: 'Delete Campaign',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteCampaign = true;
          }
        }
      ]
    }
  ];

  actionItems: any[] =
    [
      {
        label: 'Options',
        items: [
          {
            label: 'Edit Campaign',
            icon: 'pi pi-fw pi-pencil',
            command: () => {
              this.isEditCampaign = true;
            }
          },
          {
            label: 'Run Campaign',
            icon: 'pi pi-send',
            command: () => {
              this.isRunCampaign = true;
              this.run(this.editData);
            }
          },
          {
            label: 'View Report',
            icon: 'pi pi-chart-bar',
            command: () => {
              if (this.active === 'email') {
                this.isEmailReportDialogOpen = true;
              } else if (this.active === 'whatsapp') {
                this.isWhatsappReportDialogOpen = true;
              }
            }
          },
          {
            label: 'Test Campaign',
            icon: 'pi pi-fw pi-play',
            command: () => {
              if (this.active === 'email') {
                this.openTestEmailDialog = true;
              } else if (this.active === 'whatsapp') {
                this.openTestWhatsappDialog = true;
              }
            }
          },
          {
            label: 'Delete Campaign',
            icon: 'pi pi-fw pi-trash',
            styleClass: 'delete-menu-item',
            command: () => {
              this.isDeleteCampaign = true;
            }
          }
        ]
      }
    ];


  setActiveTab(tab: string) {
    this.active = tab;
    this.currentFirst = 0;
    this.loadData({ first: 0, rows: this.rows });
    
    // Load email metrics if email tab is selected
    if (tab === 'email') {
      this.loadEmailMetrics();
    }
  }

  loadEmailMetrics() {
    this.emailMetricsLoading = true;
    try {
      // Get module mapping from localStorage
      const moduleMapping = localStorage.getItem('module_mapping');
      if (moduleMapping) {
        const mapping = JSON.parse(moduleMapping);
        this.assignedEmailForMarketing = mapping['marketing_campaign'] || '';
      }
      
      // If no email found in moduleMapping, leave empty and show 'Connect Email'
      if (!this.assignedEmailForMarketing) {
        this.assignedEmailData = null;
        this.emailMetricsLoading = false;
        return;
      }

      // Fetch email data from configuration API
      const body = {
        organization_id: this.localStorage.getOrganizationId()
      };

      this.configService.getOrganizationConfig(body).subscribe({
        next: (response: any) => {
          const emailsWithMetrics = response?.emails_with_metrics || [];
          
          // Find the email data for assigned email
          const emailData = emailsWithMetrics.find((e: any) => e.email === this.assignedEmailForMarketing);
          
          if (emailData) {
            this.assignedEmailData = emailData;
          } else {
            this.assignedEmailData = null;
          }
          
          this.emailMetricsLoading = false;
        },
        error: (error: any) => {
          console.error('Error loading email metrics:', error);
          this.assignedEmailData = null;
          this.emailMetricsLoading = false;
        }
      });
    } catch (error) {
      console.error('Error in loadEmailMetrics:', error);
      this.emailMetricsLoading = false;
    }
  }

  navigateToConfiguration() {
    this.route.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 0 } });
  }

  // Start polling in background every 30 seconds
  startPolling() {
    // clear any existing
    if (this.pollingIntervalId) {
      clearInterval(this.pollingIntervalId);
    }

    this.pollingIntervalId = setInterval(() => {
      // call loadData silently to avoid toggling loader/UI
      this.loadData(
        { first: this.currentFirst, rows: this.rows },
        this.lastSearchValue,
        this.lastSearchAttribute,
        this.lastStartDate,
        this.lastEndDate,
        true
      );
    }, 60000); // 60 seconds
  }

  ngOnDestroy(): void {
    if (this.pollingIntervalId) {
      clearInterval(this.pollingIntervalId);
      this.pollingIntervalId = null;
    }
  }

  fetchContactGroups() {
    const payload = {
      "where": {
        organization_id: this.localStorage.getOrganizationId()
      },
      "order": {
        "col": "\"contact_group\".\"updatedAt\"",
        "dir": "DESC"
      }
    }
    this.api.getAllContactGroups(payload).subscribe((res: any) => {
      this.contactGroups = res;
    }
    );
  }

  fetchEmailTemplates() {

    const data = {
      "organization_id": this.localStorage.getOrganizationId(),
    }

    this.api.getAllEmailTemplates(data).subscribe((res: any) => {
      this.emailTemplates = res;
    }
    );
  }

  fetchWhatsAppTemplates() {

    const param = {
      "organization_id": this.localStorage.getOrganizationId(),
      "status": "APPROVED"
    }


    this.api.getAllWhatsappTemplatesGupshup(param).subscribe((res: any) => {

      this.whatsappTemplates = res;
    }
    );
  }

  run(event: any) {
    if (this.active === 'whatsapp') {
      this.handleGetWhatsappTemplateById(event.template_id);
    } else if (this.active === 'email') {
      this.handleGetEmailTemplateById(event.template_id);
    }

  }

  handleGetWhatsappTemplateById(id: any) {

    this.isFetchingTemplates = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "template_id": id
    }
    this.api.getTemplateById(payload).subscribe(
      (res: any) => {
        this.whatsappPreviewTemplate = res?.template_data;
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);
      }
    );
  }

  handleGetEmailTemplateById(id: any) {
    this.isFetchingTemplates = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "template_id": id
    }
    this.api.getEmailTemplateById(payload).subscribe(
      (res: any) => {
        this.processedData = this.sanitizer.bypassSecurityTrustHtml(res.template_body);
        // Extract documents/attachments if present
        this.emailTemplateDocuments = res.documents || res.attachments || [];
        this.isFetchingTemplates = false
      },
      (error: any) => {
        this.isFetchingTemplates = false
        this.emailTemplateDocuments = [];
        console.error('Error creating campaign', error);

      }

    );
  }

  runCampaign() {
    console.log("Running campaign...", this.editData);

    // Check if marketing_campaign credentials exist before running email campaign
    if (this.active === 'email') {
      const marketingCampaignCredentials = this.localStorage.getModuleMapping('marketing_campaign');
      
      if (!marketingCampaignCredentials) {
        this.isRunCampaign = false;
        this.confirmationService.confirm({
          key: 'emailConfigSteps',
          header: 'Email Configuration Required',
          message: 'Please connect your domain and assign a dedicated email address to send marketing campaigns.',
          acceptLabel: 'Connect Now',
          rejectLabel: 'Cancel',
          rejectVisible: true,
          accept: () => {
            this.route.navigate(['/main/settings/configuration-panel']);
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
        return;
      }
    }

    // Check if WhatsApp configuration exists before running WhatsApp campaign
    if (this.active === 'whatsapp') {
      const isWhatsappExist = this.localStorage.getIsWhatsappExist();
      
      if (!isWhatsappExist) {
        this.isRunCampaign = false;
        this.confirmationService.confirm({
          key: 'whatsappConfigSteps',
          header: 'WhatsApp Configuration Required',
          message: 'Please add your WhatsApp configuration to create and manage WhatsApp campaigns.',
          acceptLabel: 'Add Configuration',
          rejectLabel: 'Cancel',
          rejectVisible: true,
          accept: () => {
            this.route.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 2 } });
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
        return;
      }
    }

    if (this.active === 'email' || this.active === 'whatsapp') {

      this.btnLoading = true;

      const payload = {
        broadcastType: this.active,
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        contact_group_id: this.editData.contact_group_id,
        template_id: this.editData.template_id,
        subject: this.active === 'email' ? this.editData?.additional_details?.subject : null,
        campaign_id: this.editData?.id

      }

      this.api.runCampaign(payload).subscribe(
        (res: any) => {
          this.btnLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Campaign has been sent successfully' });
          this.isRunCampaign = false;
          this.reloadDataTable();
        },
        (error: any) => {
          console.error('Error creating campaign', error);
          this.btnLoading = false;
        }
      );
    } else if (this.active === 'call') {

      this.runCallCampaign();

    }
  }


  runCallCampaign() {

    this.btnLoading = true;
    // const selectedContactGroupId = this.editData.contact_group_id;
    const payload = {
      organizationId: this.localStorage.getOrganizationId(),
      campusId: this.localStorage.getCampusId(),
      contact_group_id: this.editData.contact_group_id,
      campaign_id: this.editData?.id,
      no_of_batches: this.editData?.additional_details?.number_of_batches,
      batch_delay: this.editData?.additional_details?.batch_delay,
      call_delay: this.editData?.additional_details?.call_delay
    }

    this.api.runCallCampaign(payload).subscribe({
      next: (res: any) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Campaign has been sent successfully' });
        this.isRunCampaign = false;
        this.reloadDataTable();
      },
      error: (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error sending campaign' });
        this.btnLoading = false;
      }
    }
    );

  }


  deleteCampaign() {
    this.btnLoading = true;
    const payload = {
      id: this.editData.id
    }
    this.api.deleteCampaign(payload).subscribe(
      (res: any) => {
        this.reloadDataTable();
        this.isDeleteCampaign = false;
        this.btnLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Campaign has been deleted successfully' });
      },
      (error: any) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error deleting campaign' });
        console.error('Error creating campaign', error);
        this.btnLoading = false;
      }
    );
  }

  testWhatsappCampaign() {
    if (!this.testPhoneNumber || !this.testPhoneNumber.internationalNumber) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a valid phone number' });
      return;
    }

    this.btnLoading = true;
    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      campaign_id: this.editData.id,
      test_phone_number: this.testPhoneNumber.internationalNumber?.replace(/[+\s]/g, '')
    }

    this.api.testWhatsappCampaign(payload).subscribe({
      next: (res: any) => {
        this.btnLoading = false;
        this.testPhoneNumber = '';
        this.openTestWhatsappDialog = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test WhatsApp campaign sent successfully' });
      },
      error: (error: any) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error sending test WhatsApp campaign' });
        console.error('Error sending test WhatsApp campaign', error);
      }
    });
  }

  testEmailCampaign() {
    if (!this.testEmail) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter an email address' });
      return;
    }

    this.btnLoading = true;
    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      campaign_id: this.editData.id,
      test_email: this.testEmail
    }

    this.api.testEmailCampaign(payload).subscribe({
      next: (res: any) => {
        this.btnLoading = false;
        this.testEmail = '';
        this.openTestEmailDialog = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test email campaign sent successfully' });
      },
      error: (error: any) => {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error sending test email campaign' });
        console.error('Error sending test email campaign', error);
      }
    });
  }


  // Map status to colors
  // Map status to professional colors
  // Map status to professional colors
  getStatusStyle(status: string) {
    switch (status) {
      case 'Running':
        return { 'background-color': '#E1F5FE', 'color': '#0277BD' };  // Blue
      case 'Scheduled':
        return { 'background-color': '#ECEFF1', 'color': '#607D8B' };  // Grayish
      case 'Pending':
        return { 'background-color': '#FFF9C4', 'color': '#FFC107' };  // Light yellowish
      case 'Completed':
        return { 'background-color': '#E8F5E9', 'color': '#2E7D32' };  // Green
      default:
        return { 'background-color': '#FFEBEE', 'color': '#C62828' };  // Red
    }
  }

  // Map status to PrimeNG icons
  getStatusIcon(status: string) {
    switch (status) {
      case 'Running':
        return 'pi pi-spin pi-sync';     // spinning sync icon
      case 'Scheduled':
        return 'pi pi-calendar';         // calendar icon
      case 'Pending':
        return 'pi pi-hourglass';        // hourglass icon
      case 'Completed':
        return 'pi pi-check-circle';     // check icon
      default:
        return 'pi pi-exclamation-circle';
    }
  }

  // Toggle minimize/maximize SIP Dialer
  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
  }

  // Format schedule date in IST timezone
  formatScheduleDateInIST(dateStr: string): string {
    if (!dateStr) {
      return 'N/A';
    }
    try {
      // Parse the UTC datetime and convert to IST (UTC+5:30)
      const istTime = moment.utc(dateStr).tz('Asia/Kolkata');
      return istTime.format('DD/MM/YYYY HH:mm');
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'N/A';
    }
  }

}
